var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateCart } from "../../../data/api";
import { getPaymentMethodId, log, Style } from "../../../data/helpers";
import { setCartData } from "../../../store/Cart/actions";
import { phone } from "phone";
import Skeleton from "@material-ui/lab/Skeleton";
import { PaymentSourceTypes } from "@brushfire/types";
import { Button, HorizontalRule } from "@brushfire/ui";
import { useSpecificBFPayment } from "../../../hooks/useSpecificBFPayment";
var TokenType;
(function (TokenType) {
    TokenType[TokenType["ApplePay"] = 0] = "ApplePay";
    TokenType[TokenType["GooglePay"] = 1] = "GooglePay";
    TokenType[TokenType["AfterPay"] = 2] = "AfterPay";
})(TokenType || (TokenType = {}));
var SquareWalletButton = function (_a) {
    var _b, _c, _d, _e;
    var payments = _a.payments, widgetPaymentRequest = _a.widgetPaymentRequest, setWalletConfirmationPayload = _a.setWalletConfirmationPayload, setErrorMessage = _a.setErrorMessage, formikContext = _a.formikContext, loading = _a.loading, eventNumber = _a.eventNumber;
    var _f = __read(useState(), 2), applePay = _f[0], setApplePay = _f[1];
    var _g = __read(useState(), 2), googlePay = _g[0], setGooglePay = _g[1];
    var _h = __read(useState(), 2), afterPay = _h[0], setAfterPay = _h[1];
    var _j = __read(useState(), 2), paymentRequest = _j[0], setPaymentRequest = _j[1];
    var _k = __read(useState(), 2), afterPaymentRequest = _k[0], setAfterPaymentRequest = _k[1];
    var _l = __read(React.useState(widgetPaymentRequest), 2), localPaymentRequest = _l[0], setLocalPaymentRequest = _l[1];
    var totalRef = React.useRef(localPaymentRequest.total);
    var shippingIdRef = React.useRef(localPaymentRequest.shippingId);
    useEffect(function () {
        totalRef.current = widgetPaymentRequest.total;
        shippingIdRef.current = widgetPaymentRequest.shippingId;
        setLocalPaymentRequest(widgetPaymentRequest);
    }, [widgetPaymentRequest.total, widgetPaymentRequest.shippingId]);
    useEffect(function () {
        if (applePay !== undefined && googlePay !== undefined && afterPay !== undefined) {
            setTimeout(function () {
                if (googlePay) {
                    googlePay.attach("#google-pay-button", { buttonType: "short", buttonSizeMode: "fill" });
                }
            }, 100);
            setTimeout(function () {
                if (afterPay) {
                    afterPay.attach("#afterpay-button", {
                        useCustomButton: true,
                    });
                }
            }, 100);
        }
    }, [applePay, googlePay, afterPay]);
    var dispatch = useDispatch();
    var _m = useSpecificBFPayment(widgetPaymentRequest.paymentMethods), paymentSourceTypes = _m.paymentSourceTypes, bfPaymentInvalid = _m.bfPaymentInvalid;
    var getShippingOption = function (ref) {
        var _a, _b, _c, _d, _e, _f;
        var shippingId = ref.current;
        var deliveryMethod = widgetPaymentRequest.deliveryMethods.find(function (d) { return d.shippingId === shippingId; });
        var payload = [
            {
                amount: (_b = ((_a = deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.fee) !== null && _a !== void 0 ? _a : 0).toFixed(2)) !== null && _b !== void 0 ? _b : "0.00",
                id: (_c = deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.shippingId) !== null && _c !== void 0 ? _c : "shipping-id-1",
                label: (_d = deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.method) !== null && _d !== void 0 ? _d : "No Shipping",
                taxLineItems: [
                    {
                        amount: "0.00",
                        label: "Taxes",
                    },
                ],
                total: {
                    amount: (_f = ((_e = totalRef.current) !== null && _e !== void 0 ? _e : 0).toFixed(2)) !== null && _f !== void 0 ? _f : "0.00",
                    label: "total",
                },
            },
        ];
        return payload;
    };
    var updatePaymentRequests = function (widgetRequest) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        paymentRequest === null || paymentRequest === void 0 ? void 0 : paymentRequest.update({
            countryCode: widgetRequest.currency.toUpperCase() === "USD" ? "US" : widgetRequest.country,
            currencyCode: widgetRequest.currency.toUpperCase(),
            lineItems: widgetRequest.lineItems.map(function (lineItem) { return ({
                amount: lineItem.amount.toFixed(2),
                label: lineItem.label,
                pending: false,
            }); }),
            requestBillingContact: true,
            requestShippingContact: false,
            total: {
                amount: widgetRequest.total.toFixed(2),
                label: (_d = (_b = (_a = widgetRequest.paymentProfile) === null || _a === void 0 ? void 0 : _a.config.locationName) !== null && _b !== void 0 ? _b : (_c = widgetRequest.paymentProfile) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "Total",
                pending: false,
            },
        });
        afterPaymentRequest === null || afterPaymentRequest === void 0 ? void 0 : afterPaymentRequest.update({
            countryCode: widgetRequest.currency.toUpperCase() === "USD" ? "US" : widgetRequest.country,
            currencyCode: widgetRequest.currency.toUpperCase(),
            lineItems: widgetRequest.lineItems.map(function (lineItem) { return ({
                amount: lineItem.amount.toFixed(2),
                label: lineItem.label,
                pending: false,
            }); }),
            requestBillingContact: true,
            requestShippingContact: true,
            shippingOptions: getShippingOption(shippingIdRef),
            total: {
                amount: widgetRequest.total.toFixed(2),
                label: (_h = (_f = (_e = widgetRequest.paymentProfile) === null || _e === void 0 ? void 0 : _e.config.locationName) !== null && _f !== void 0 ? _f : (_g = widgetRequest.paymentProfile) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : "Total",
                pending: false,
            },
        });
    };
    var generatePaymentRequest = function (payments, widgetPaymentRequest) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentRequestOptions, createdPaymentRequest, createdAfterPaymentRequest, oldMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            paymentRequestOptions = {
                countryCode: widgetPaymentRequest.currency.toUpperCase() === "USD" ? "US" : widgetPaymentRequest.country,
                currencyCode: widgetPaymentRequest.currency.toUpperCase(),
                lineItems: widgetPaymentRequest.lineItems.map(function (lineItem) { return ({
                    amount: lineItem.amount.toFixed(2),
                    label: lineItem.label,
                    pending: false,
                }); }),
                requestBillingContact: true,
                requestShippingContact: false,
                total: {
                    amount: widgetPaymentRequest.total.toFixed(2),
                    label: (_b = (_a = widgetPaymentRequest.paymentProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Total",
                    pending: false,
                },
            };
            console.log(paymentRequestOptions);
            createdPaymentRequest = payments.paymentRequest(paymentRequestOptions);
            createdAfterPaymentRequest = payments.paymentRequest(__assign(__assign({}, paymentRequestOptions), { requestShippingContact: true, shippingOptions: getShippingOption(shippingIdRef) }));
            createdPaymentRequest.addEventListener("shippingoptionchanged", function (option) { return __awaiter(void 0, void 0, void 0, function () {
                var data_1, newDeliveryMethod;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!widgetPaymentRequest.cartId) return [3 /*break*/, 2];
                            return [4 /*yield*/, updateCart(widgetPaymentRequest.cartId, { shippingId: option.id }, eventNumber)];
                        case 1:
                            data_1 = (_c.sent()).data;
                            if (data_1) {
                                dispatch(setCartData(data_1));
                                newDeliveryMethod = data_1.deliveryMethods.find(function (d) { return d.shippingId === data_1.shippingId; });
                                return [2 /*return*/, {
                                        total: {
                                            label: (_b = (_a = widgetPaymentRequest.paymentProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Total",
                                            amount: data_1.total.toFixed(2),
                                            pending: false,
                                        },
                                        shippingOptions: getShippingOption(shippingIdRef),
                                    }];
                            }
                            else {
                                return [2 /*return*/, {}];
                            }
                            return [3 /*break*/, 3];
                        case 2: return [2 /*return*/, {}];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            createdAfterPaymentRequest.addEventListener("afterpay_shippingoptionchanged", function (option) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, {}];
                });
            }); });
            createdAfterPaymentRequest === null || createdAfterPaymentRequest === void 0 ? void 0 : createdAfterPaymentRequest.addEventListener("afterpay_shippingaddresschanged", function (contact) {
                return {
                    shippingOptions: getShippingOption(shippingIdRef),
                };
            });
            if ((_d = (_c = widgetPaymentRequest.paymentProfile) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.allowWallets) {
                payments
                    .applePay(createdPaymentRequest)
                    .then(function (newApplePay) {
                    setApplePay(newApplePay);
                })
                    .catch(function (err) {
                    setApplePay(null);
                    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    if (window.brushfireDebugMode) {
                        log("Apple Pay unavailable on this device at this time.", Style.base);
                        console.log(err);
                    }
                });
                payments
                    .googlePay(createdPaymentRequest)
                    .then(function (newGooglePay) {
                    setGooglePay(newGooglePay);
                })
                    .catch(function (err) {
                    setGooglePay(null);
                    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    if (window.brushfireDebugMode) {
                        log("Google Pay unavailable on this device at this time.", Style.base);
                    }
                });
            }
            else {
                setApplePay(null);
                setGooglePay(null);
            }
            if ((_f = (_e = widgetPaymentRequest.paymentProfile) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.allowAfterpay) {
                if (afterPay) {
                    oldMessage = document.getElementById("afterpay-message");
                    if (oldMessage) {
                        oldMessage.innerHTML = "";
                    }
                    afterPay.destroy();
                }
                payments
                    .afterpayClearpay(createdAfterPaymentRequest)
                    .then(function (newAfterPay) {
                    newAfterPay.addEventListener("afterpay_shippingaddresschanged", function (option) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            debugger;
                            return [2 /*return*/];
                        });
                    }); });
                    setAfterPay(newAfterPay);
                })
                    .catch(function (err) {
                    setAfterPay(null);
                    console.log("Payment Method Error (After Pay)", err);
                    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    if (window.brushfireDebugMode) {
                        log("AfterPay unavailable on this device at this time.", Style.base);
                    }
                });
            }
            else {
                setAfterPay(null);
            }
            setPaymentRequest(createdPaymentRequest);
            setAfterPaymentRequest(createdAfterPaymentRequest);
            return [2 /*return*/];
        });
    }); };
    var getToken = function (tokenType) { return __awaiter(void 0, void 0, void 0, function () {
        var tokenResult, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    formikContext.setSubmitting(true);
                    tokenResult = undefined;
                    if (!(applePay && tokenType === TokenType.ApplePay)) return [3 /*break*/, 2];
                    return [4 /*yield*/, applePay.tokenize()];
                case 1:
                    tokenResult = _b.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!(googlePay && tokenType === TokenType.GooglePay)) return [3 /*break*/, 4];
                    return [4 /*yield*/, googlePay.tokenize()];
                case 3:
                    tokenResult = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    if (!(afterPay && tokenType === TokenType.AfterPay)) return [3 /*break*/, 6];
                    return [4 /*yield*/, afterPay.tokenize()];
                case 5:
                    tokenResult = _b.sent();
                    _b.label = 6;
                case 6:
                    if (tokenResult) {
                        if (tokenResult.status === "OK" && tokenResult.token) {
                            getPaymentMethodId("square")
                                .then(function (paymentMethodId) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50;
                                if (tokenResult && tokenResult.token) {
                                    var payload = {
                                        address: {
                                            street1: (_j = (_d = (_c = (_b = (_a = tokenResult.details) === null || _a === void 0 ? void 0 : _a.billing) === null || _b === void 0 ? void 0 : _b.addressLines) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : (_h = (_g = (_f = (_e = tokenResult.details) === null || _e === void 0 ? void 0 : _e.shipping) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.addressLines) === null || _h === void 0 ? void 0 : _h[0]) !== null && _j !== void 0 ? _j : "",
                                            street2: (_t = (_o = (_m = (_l = (_k = tokenResult.details) === null || _k === void 0 ? void 0 : _k.billing) === null || _l === void 0 ? void 0 : _l.addressLines) === null || _m === void 0 ? void 0 : _m[1]) !== null && _o !== void 0 ? _o : (_s = (_r = (_q = (_p = tokenResult.details) === null || _p === void 0 ? void 0 : _p.shipping) === null || _q === void 0 ? void 0 : _q.contact) === null || _r === void 0 ? void 0 : _r.addressLines) === null || _s === void 0 ? void 0 : _s[1]) !== null && _t !== void 0 ? _t : "",
                                            city: (_0 = (_w = (_v = (_u = tokenResult.details) === null || _u === void 0 ? void 0 : _u.billing) === null || _v === void 0 ? void 0 : _v.city) !== null && _w !== void 0 ? _w : (_z = (_y = (_x = tokenResult.details) === null || _x === void 0 ? void 0 : _x.shipping) === null || _y === void 0 ? void 0 : _y.contact) === null || _z === void 0 ? void 0 : _z.city) !== null && _0 !== void 0 ? _0 : "",
                                            region: (_7 = (_3 = (_2 = (_1 = tokenResult.details) === null || _1 === void 0 ? void 0 : _1.billing) === null || _2 === void 0 ? void 0 : _2.state) !== null && _3 !== void 0 ? _3 : (_6 = (_5 = (_4 = tokenResult.details) === null || _4 === void 0 ? void 0 : _4.shipping) === null || _5 === void 0 ? void 0 : _5.contact) === null || _6 === void 0 ? void 0 : _6.state) !== null && _7 !== void 0 ? _7 : "",
                                            country: (_14 = (_10 = (_9 = (_8 = tokenResult.details) === null || _8 === void 0 ? void 0 : _8.billing) === null || _9 === void 0 ? void 0 : _9.countryCode) !== null && _10 !== void 0 ? _10 : 
                                            //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            (_13 = (_12 = (_11 = tokenResult.details) === null || _11 === void 0 ? void 0 : _11.shipping) === null || _12 === void 0 ? void 0 : _12.contact) === null || _13 === void 0 ? void 0 : _13.country) !== null && _14 !== void 0 ? _14 : "",
                                            postalCode: (_21 = (_17 = (_16 = (_15 = tokenResult.details) === null || _15 === void 0 ? void 0 : _15.billing) === null || _16 === void 0 ? void 0 : _16.postalCode) !== null && _17 !== void 0 ? _17 : (_20 = (_19 = (_18 = tokenResult.details) === null || _18 === void 0 ? void 0 : _18.shipping) === null || _19 === void 0 ? void 0 : _19.contact) === null || _20 === void 0 ? void 0 : _20.postalCode) !== null && _21 !== void 0 ? _21 : "",
                                        },
                                        tokenInfo: { token: tokenResult.token, method: (_23 = (_22 = tokenResult.details) === null || _22 === void 0 ? void 0 : _22.method) !== null && _23 !== void 0 ? _23 : "" },
                                        phone: (_37 = phone(
                                        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        //@ts-ignore
                                        !!((_25 = (_24 = tokenResult.details) === null || _24 === void 0 ? void 0 : _24.billing) === null || _25 === void 0 ? void 0 : _25.phone)
                                            ? (_26 = tokenResult.details) === null || _26 === void 0 ? void 0 : _26.billing.phone
                                            : (_30 = (_29 = (_28 = (_27 = tokenResult.details) === null || _27 === void 0 ? void 0 : _27.shipping) === null || _28 === void 0 ? void 0 : _28.contact) === null || _29 === void 0 ? void 0 : _29.phone) !== null && _30 !== void 0 ? _30 : "", {
                                            country: (_33 = (_32 = (_31 = tokenResult.details) === null || _31 === void 0 ? void 0 : _31.billing) === null || _32 === void 0 ? void 0 : _32.countryCode) !== null && _33 !== void 0 ? _33 : 
                                            //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            (_36 = (_35 = (_34 = tokenResult.details) === null || _34 === void 0 ? void 0 : _34.shipping) === null || _35 === void 0 ? void 0 : _35.contact) === null || _36 === void 0 ? void 0 : _36.country,
                                            validateMobilePrefix: false,
                                        }).phoneNumber) !== null && _37 !== void 0 ? _37 : "",
                                        firstName: (_40 = (_39 = (_38 = tokenResult.details) === null || _38 === void 0 ? void 0 : _38.billing) === null || _39 === void 0 ? void 0 : _39.givenName) !== null && _40 !== void 0 ? _40 : "",
                                        lastName: (_43 = (_42 = (_41 = tokenResult.details) === null || _41 === void 0 ? void 0 : _41.billing) === null || _42 === void 0 ? void 0 : _42.familyName) !== null && _43 !== void 0 ? _43 : "",
                                        email: 
                                        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        //@ts-ignore
                                        (_50 = (_46 = (_45 = (_44 = tokenResult.details) === null || _44 === void 0 ? void 0 : _44.billing) === null || _45 === void 0 ? void 0 : _45.email) !== null && _46 !== void 0 ? _46 : (_49 = (_48 = (_47 = tokenResult.details) === null || _47 === void 0 ? void 0 : _47.shipping) === null || _48 === void 0 ? void 0 : _48.contact) === null || _49 === void 0 ? void 0 : _49.email) !== null && _50 !== void 0 ? _50 : "",
                                        paymentMethodId: paymentMethodId,
                                    };
                                    if (!payload.address.street1) {
                                        setErrorMessage("There was no associated billing address with the card you selected. Please visit your ".concat(TokenType[tokenType], " account and add a billing address with your card."));
                                        formikContext.setSubmitting(false);
                                    }
                                    else {
                                        setWalletConfirmationPayload(payload);
                                    }
                                }
                            })
                                .catch(function (errorMessage) {
                                setErrorMessage(errorMessage);
                                formikContext.setSubmitting(false);
                            });
                        }
                        else {
                            errorMessage = (_a = tokenResult.errors) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e.message; }).join(". ");
                            if (errorMessage) {
                                setErrorMessage(errorMessage);
                            }
                            formikContext.setSubmitting(false);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (payments && !paymentRequest) {
            generatePaymentRequest(payments, widgetPaymentRequest);
        }
    }, [payments]);
    useEffect(function () {
        if (localPaymentRequest && paymentRequest) {
            updatePaymentRequests(localPaymentRequest);
        }
    }, [localPaymentRequest.total, localPaymentRequest.shippingId]);
    if (applePay === undefined || googlePay === undefined || afterPay === undefined) {
        return (_jsxs(_Fragment, { children: [((_c = (_b = widgetPaymentRequest.paymentProfile) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.allowWallets) && (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }), _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" })] })), ((_e = (_d = widgetPaymentRequest.paymentProfile) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.allowAfterpay) && (_jsx(_Fragment, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }));
    }
    if (!payments || (!applePay && !googlePay && !afterPay)) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "".concat(!!localPaymentRequest.shippingId ? "" : "disabled", " ").concat(loading ? "wallets-disabled" : "") }, { children: [_jsx(HorizontalRule, { children: "PAY NOW" }), applePay && (bfPaymentInvalid || paymentSourceTypes.includes(PaymentSourceTypes.APPLE_PAY)) && (_jsx("button", { className: "apple-pay-button apple-pay-button-black", onClick: function (evt) {
                    if (!widgetPaymentRequest.shippingId && !!widgetPaymentRequest.cartId) {
                        formikContext.submitForm();
                    }
                    else {
                        evt.preventDefault();
                        evt.stopPropagation();
                        getToken(TokenType.ApplePay);
                    }
                } })), googlePay && (bfPaymentInvalid || paymentSourceTypes.includes(PaymentSourceTypes.GOOGLE_PAY)) && (_jsx("div", { id: "google-pay-button", className: "google-pay-button ".concat(!!applePay ? "m-top-sm" : ""), onClick: function (evt) {
                    if (!widgetPaymentRequest.shippingId && !!widgetPaymentRequest.cartId) {
                        formikContext.submitForm();
                    }
                    else {
                        evt.preventDefault();
                        evt.stopPropagation();
                        getToken(TokenType.GooglePay);
                    }
                } })), afterPay && (bfPaymentInvalid || paymentSourceTypes.includes(PaymentSourceTypes.BUY_NOW_PAY_LATER)) && (_jsx(Button, __assign({ id: "afterpay-button", classes: "".concat(!!applePay || !!googlePay ? "m-top-sm" : "", " afterpay-button btn-block"), onClick: function (evt) {
                    if (!widgetPaymentRequest.shippingId && !!widgetPaymentRequest.cartId) {
                        formikContext.submitForm();
                    }
                    else {
                        getToken(TokenType.AfterPay);
                    }
                }, purpose: "dark" }, { children: _jsxs("svg", __assign({ width: "100", viewBox: "0 0 601 116", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsxs("g", __assign({ clipPath: "url(#clip0_341_18)" }, { children: [_jsx("path", { d: "M554.312 2.27881L592.584 24.3246C603.817 30.7974 603.817 46.991 592.584 53.4464L554.312 75.498C543.074 81.9766 529.038 73.8798 529.038 60.9284V57.9298C529.037 57.2877 528.867 56.6572 528.545 56.1016C528.223 55.546 527.761 55.0849 527.206 54.7646C526.65 54.4443 526.02 54.2761 525.378 54.2768C524.737 54.2775 524.107 54.4472 523.552 54.7688L490.406 73.8682C489.85 74.1886 489.388 74.65 489.067 75.206C488.746 75.7619 488.577 76.3928 488.577 77.035C488.577 77.6772 488.746 78.3081 489.067 78.864C489.388 79.42 489.85 79.8814 490.406 80.2018L523.552 99.307C524.107 99.6288 524.738 99.7985 525.38 99.799C526.022 99.7995 526.652 99.6308 527.208 99.3098C527.764 98.9888 528.226 98.5269 528.547 97.9705C528.868 97.4141 529.038 96.7828 529.038 96.1402V90.5142C529.038 88.0724 531.679 86.5412 533.805 87.765L541.029 91.941C541.898 92.4415 542.621 93.162 543.124 94.0304C543.627 94.8988 543.894 95.8844 543.896 96.8884V99.1504C543.896 112.108 529.843 120.193 518.611 113.72L480.344 91.6742C469.111 85.2014 469.111 69.002 480.344 62.535L518.611 40.4834C529.854 33.999 543.896 42.1016 543.896 55.053V58.0458C543.895 58.6883 544.063 59.3196 544.384 59.8763C544.704 60.4329 545.166 60.8951 545.721 61.2162C546.277 61.5374 546.908 61.7061 547.549 61.7055C548.191 61.7049 548.821 61.5349 549.376 61.2126L582.522 42.1074C583.08 41.7898 583.544 41.33 583.866 40.7748C584.189 40.2196 584.359 39.5887 584.359 38.9464C584.359 38.3041 584.189 37.6732 583.866 37.118C583.544 36.5628 583.08 36.103 582.522 35.7854L549.376 16.686C548.821 16.3638 548.191 16.1937 547.549 16.1931C546.908 16.1925 546.277 16.3612 545.721 16.6824C545.166 17.0036 544.704 17.4657 544.384 18.0224C544.063 18.579 543.895 19.2103 543.896 19.8528V25.4788C543.895 26.0368 543.747 26.5847 543.468 27.0674C543.188 27.5501 542.787 27.9506 542.303 28.2287C541.82 28.5067 541.273 28.6525 540.715 28.6514C540.158 28.6502 539.611 28.5022 539.129 28.2222L531.899 24.0578C531.031 23.5571 530.309 22.8363 529.807 21.9678C529.304 21.0994 529.039 20.1139 529.038 19.1104V16.8484C529.038 3.89121 543.074 -4.194 554.312 2.27881ZM132.326 66.8154C132.326 72.0296 133.808 74.0132 139.161 74.0132H142.272V87.794H134.191C121.51 87.794 116.668 82.3304 116.668 69.669V39.2654H96.4857V87.794H80.8162V39.2538H72.1155V25.7224H80.8162V19.8412C80.8162 6.93621 86.9102 2.71381 99.8339 2.71381H107.376V14.7546H103.941C98.4668 14.7546 96.4741 16.744 96.4741 21.9582V25.7282H116.656V10.5902H132.326V25.7282H142.15V39.2654H132.326V66.8154Z", fill: "white" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.6035 79.7278V87.7955H64.8964V25.7355H49.6093V33.5598C47.2574 30.7369 44.3095 28.4716 40.9779 26.9271C37.6462 25.3826 34.0138 24.5972 30.3425 24.6278C13.4276 24.6278 0 38.5188 0 56.7656C0 75.1284 12.9294 88.7815 29.9602 88.7815C38.157 88.7815 45.0098 85.3132 49.6035 79.7278ZM32.5611 39.0117C41.8817 39.0117 49.4645 46.3372 49.4645 56.7656C49.4645 67.1882 41.8875 74.5135 32.5611 74.5193C23.2348 74.5193 15.652 66.9446 15.652 56.7656C15.652 46.4648 23.2406 39.0176 32.5611 39.0176V39.0117ZM164.15 60.8604C165.274 70.0418 171.86 75.2617 180.19 75.2617C186.776 75.2617 191.88 72.1529 194.857 67.1881H210.897C207.167 80.3425 195.355 88.7874 179.819 88.7874C161.045 88.7874 147.872 75.633 147.872 56.8874C147.872 38.1476 161.798 24.6104 180.202 24.6104C198.727 24.6104 212.149 38.2694 212.149 56.8874C212.149 58.2562 212.021 59.6134 211.772 60.8604H164.15ZM195.355 51.1744C194.237 43.1124 187.645 38.2693 179.941 38.2693C172.231 38.2693 165.888 42.9848 164.283 51.1744H195.355ZM277.821 25.7355H262.534V113.333H278.314V80.476C282.791 85.6844 289.256 88.7932 297.088 88.7932C313.997 88.7932 327.419 74.8906 327.419 56.6438C327.419 38.4028 314.246 24.6278 297.459 24.6278C289.256 24.6278 282.421 28.0904 277.821 33.8034V25.7355ZM294.864 39.0176C304.178 39.0176 311.767 46.7084 311.767 56.7656C311.767 66.8228 304.178 74.5135 294.864 74.5193C285.543 74.5193 277.955 66.9446 277.955 56.7656C277.955 46.4648 285.543 39.0176 294.864 39.0176ZM382.659 79.7278C378.065 85.3132 371.218 88.7874 363.021 88.7874C345.991 88.7874 333.067 75.1284 333.067 56.7656C333.067 38.5188 346.489 24.622 363.392 24.622C371.351 24.622 378.065 28.102 382.659 33.554V25.7414H397.952V87.8014H382.659V79.7278ZM382.526 56.7656C382.526 46.3372 374.949 39.0176 365.622 39.0176C356.302 39.0176 348.713 46.4648 348.713 56.7656C348.713 66.9446 356.302 74.5193 365.622 74.5193C374.949 74.5077 382.526 67.1882 382.526 56.7656Z", fill: "white" }), _jsx("path", { d: "M248.404 24.6217C238.881 24.6217 234.982 31.8137 234.982 31.8137V25.7527H219.695V87.8127H235.481V51.0697C235.463 44.5853 238.8 39.7423 244.083 39.0289C249.372 38.3155 255.118 41.8593 255.118 41.8593V26.0253C255.118 26.0253 252.482 24.6333 248.404 24.6333V24.6217ZM469.37 25.7353L430.767 113.135H414.489L429.643 79.3447L404.016 25.7353H422.466L437.457 61.5561L452.843 25.7353H469.37Z", fill: "white" })] })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_341_18" }, { children: _jsx("rect", { width: "601", height: "116", fill: "white" }) })) })] })) })))] })));
};
export default SquareWalletButton;
